export const getAircraftTechSpecsReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-asset-report/aircraft/${queryString ? `?${queryString}` : ''}`;
}
export const getEngineTechSpecsReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-asset-report/engine/${queryString ? `?${queryString}` : ''}`;
}
export const getEngineSummaryReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/engine-summary-report/${queryString ? `?${queryString}` : ''}`;
}
export const getEngineLLPLimiterReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/engine-llp-limiter-due/${queryString ? `?${queryString}` : ''}`;
}
export const getFleetSummaryValuationsReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-valuation-portfolio-report/${queryString ? `?${queryString}` : ''}`;
}
export const getAccountsReceivableReportApi = (query) => {
    return `reports/export-statement-report/`;
}
export const getAssetInfoLogReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-asset-log-report/${queryString ? `?${queryString}` : ''}`;
}
export const getDeconsolidateInvoicesReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-deconsolidated-billings/${queryString ? `?${queryString}` : ''}`;
}
export const getEngineFleetReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-engine-fleet/${queryString ? `?${queryString}` : ''}`;
}
export const getEngineSwapReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/engine-swap-report/${queryString ? `?${queryString}` : ''}`;
}
export const getPaymentReceivedReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-statement-report/${queryString ? `?${queryString}` : ''}`;
}
export const getFleetInformationReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-portfolio-report/${queryString ? `?${queryString}` : ''}`;
}
export const getMonthlyRevenueReportApi = () => {
    return `reports/monthly-revenue-report/`;
}
export const getMRFundBalanceReportApi = () => {
    return `reports/export-mr-fund-balance-report/`;
}
export const getInsuranceOverviewReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-insurance-overview/${queryString ? `?${queryString}` : ''}`;
}
export const getUtilizationInvoiceReportApi = () => {
    return `reports/export-utilisation-invoice-report/`;
}
export const getContarctExpiryReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-contract-expiry-report/${queryString ? `?${queryString}` : ''}`;
}
export const getLessorApi = () => {
    return `api/dropdown/fleet_lessor/`;
}
export const getLesseeApi = () => {
    return `api/dropdown/lessee/`;
}
export const getAssetApi = () => {
    return `api/dropdown/fleet_asset/?include_on_wing=true`;
}
export const getAircraftTypeList = () => {
  return `/console/aircraft-types/`
}
export const getEngineTypeList = () => {
  return `/config/engine-types/`
}

export const getApuTypeList = () => {
  return `/console/apu-types/`
}
export const getReportConstantsApi = () => {
  return `lease/constants/get_by_constant_types`;
}
export const getLeaseCountriesApi = () => {
  return `lease/countries`;
}
export const getPortfolioReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-portfolio-overview-report/${queryString ? `?${queryString}` : ''}`;
}
export const getOpsReportApi = (query) => {
    const queryString = new URLSearchParams(query).toString();
    return `reports/export-ops-report/${queryString ? `?${queryString}` : ''}`;
}
